<template>
  <div class="warehouse-inbound">
    <div class="inbound-mask"></div>
    <div class="inbound-modal">
      <div class="modal-header">
        <span>新增入仓</span>
        <img
          src="@/assets/images/close@2x.png"
          alt=""
          class="icon-close"
          @click="onClose"
        />
      </div>

      <div class="modal-body">
        <!-- 商品选择（可多选） -->
        <div class="section">
          <div class="section-title">选择商品（可多选）</div>
          <div class="product-search">
            <input
              v-model="keyword"
              type="text"
              placeholder="输入商品名称搜索"
              @keyup.enter="searchProduct"
            />
            <div class="search-btn" @click="searchProduct">搜索</div>
          </div>
          <div class="product-list">
            <div
              v-for="(item, index) in product_list"
              :key="`p${index}`"
              class="product-item"
              :class="{ active: isSelected(item.id) }"
              @click="toggleSelect(item)"
            >
              <div class="check-box">
                <img
                  v-if="isSelected(item.id)"
                  src="@/assets/images/icon-checked.png"
                  alt=""
                />
                <img
                  v-else
                  src="@/assets/images/icon-uncheck.png"
                  alt=""
                />
              </div>
              <img :src="item.image" alt="" class="product-img" />
              <div class="product-text">
                <div class="p-name">{{ item.name }}</div>
                <div class="p-no">款号：{{ item.style_no || '-' }}</div>
              </div>
            </div>
            <div v-if="!product_list.length" class="empty">请先搜索选择商品</div>
          </div>
        </div>

        <!-- 已选商品规格数量 -->
        <template v-if="selected_products.length">
          <div class="section">
            <div class="section-title">已选商品寄出数量（按颜色/尺码）</div>
            <div
              v-for="(sp, idx) in selected_products"
              :key="`sp${sp.id}`"
              class="selected-product"
            >
              <div class="selected-head">
                <span class="sp-name">{{ sp.name }}（款号：{{ sp.style_no || '-' }}）</span>
                <span class="sp-remove" @click="removeSelected(idx)">移除</span>
              </div>
              <div class="spec-grid">
                <div class="spec-head">
                  <span>颜色</span>
                  <span>尺码</span>
                  <span>寄出数量</span>
                </div>
                <div
                  v-for="(spec, sIndex) in sp.spec_data"
                  :key="`s${idx}-${sIndex}`"
                  class="spec-row"
                >
                  <span>{{ spec.attr2_name || '-' }}</span>
                  <span>{{ spec.attr1_name || '-' }}</span>
                  <input
                    v-model="spec.send_num"
                    type="number"
                    min="0"
                    placeholder="0"
                    class="spec-input"
                  />
                </div>
              </div>
            </div>
          </div>
        </template>

        <!-- 物流信息 -->
        <div class="section">
          <div class="section-title">物流信息</div>
          <div class="info-row">
            <div class="info-label">物流公司</div>
            <Select
              v-model="form_data.logistics_id"
              placeholder="请选择物流公司"
              class="form-select"
              @on-change="onCompanyChange"
            >
              <Option
                v-for="(item, index) in logistics_company_list"
                :key="index"
                :value="item.id"
              >{{ item.name }}</Option>
            </Select>
          </div>
          <div class="info-row">
            <div class="info-label">运单号</div>
            <input
              v-model="form_data.logistics_no"
              type="text"
              placeholder="请输入运单号"
              class="form-input"
            />
          </div>
          <div class="info-row">
            <div class="info-label">寄出时间</div>
            <DatePicker
              class="date-picker"
              type="date"
              format="yyyy-MM-dd"
              placeholder="选择寄出时间"
              :value="sendTimeValue"
              @on-change="onSendTimeChange"
              transfer
            ></DatePicker>
          </div>
          <div class="info-row">
            <div class="info-label">备注</div>
            <input
              v-model="form_data.remark"
              type="text"
              placeholder="选填"
              class="form-input"
            />
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="cancel-btn" @click="onClose">取消</button>
        <button class="confirm-btn" :loading="submitting" @click="onSubmit">
          确认寄出
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import {
  WarehouseProductList,
  WarehouseInboundCreate,
  logisticsCompanyList,
} from "@/api/index";
export default {
  name: "WarehouseInbound",
  data() {
    return {
      keyword: "",
      product_list: [],
      selected_products: [],
      logistics_company_list: [],
      form_data: {
        logistics_id: "",
        logistics_company: "",
        logistics_no: "",
        remark: "",
      },
      sendTimeValue: "",
      submitting: false,
    };
  },
  mounted() {
    this.searchProduct();
    this.onGetLogisticsCompanyList();
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
    async onGetLogisticsCompanyList() {
      try {
        const { code, msg, data } = await logisticsCompanyList();
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
        this.logistics_company_list = data;
      } catch (e) {
        console.log("err-logistics-company-list", e);
      }
    },
    onCompanyChange(id) {
      const target = this.logistics_company_list.find(
        (item) => item.id == id
      );
      this.form_data.logistics_company = target ? target.name : "";
    },
    async searchProduct() {
      try {
        const { data } = await WarehouseProductList({ keyword: this.keyword });
        this.product_list = data.list;
      } catch (e) {
        console.log("e-product", e);
      }
    },
    isSelected(id) {
      return this.selected_products.some((sp) => sp.id == id);
    },
    toggleSelect(item) {
      const idx = this.selected_products.findIndex((sp) => sp.id == item.id);
      if (idx > -1) {
        this.selected_products.splice(idx, 1);
      } else {
        this.selected_products.push({
          id: item.id,
          uuid: item.uuid,
          name: item.name,
          image: item.image,
          style_no: item.style_no,
          spec_data: (item.specs || []).map((s) => ({
            spec_id: s.spec_id,
            attr1_name: s.attr1_name,
            attr2_name: s.attr2_name,
            send_num: 0,
          })),
        });
      }
    },
    removeSelected(idx) {
      this.selected_products.splice(idx, 1);
    },
    onSendTimeChange(date) {
      this.sendTimeValue = date;
      this.form_data.send_time = date
        ? Math.floor(new Date(date).getTime() / 1000)
        : 0;
    },
    async onSubmit() {
      if (!this.selected_products.length) {
        this.$layer.msg("请选择商品");
        return;
      }
      if (!this.form_data.logistics_company) {
        this.$layer.msg("请填写物流公司");
        return;
      }
      if (!this.form_data.logistics_no) {
        this.$layer.msg("请填写运单号");
        return;
      }
      const product_list = this.selected_products.map((sp) => ({
        product_id: sp.id,
        spec_data: (sp.spec_data || []).filter((s) => s.send_num > 0),
      })).filter((p) => p.spec_data.length > 0);
      if (!product_list.length) {
        this.$layer.msg("请填写寄出数量");
        return;
      }
      const param = {
        product_list,
        logistics_company: this.form_data.logistics_company,
        logistics_no: this.form_data.logistics_no,
        send_time: this.form_data.send_time || Math.floor(Date.now() / 1000),
        remark: this.form_data.remark,
      };
      this.submitting = true;
      try {
        await WarehouseInboundCreate(param);
        this.$emit("success");
      } catch (e) {
        console.log("e-submit", e);
        if (e && e.msg) this.$layer.msg(e.msg);
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.warehouse-inbound {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1001;
  .inbound-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
  }
  .inbound-modal {
    position: relative;
    width: 760px;
    max-height: 90vh;
    margin: 5vh auto 0;
    background: #ffffff;
    border-radius: 10px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .modal-header {
      height: 56px;
      padding: 0 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #f0f0f0;
      font-size: 16px;
      font-weight: 600;
      color: #1a1a1a;
      .icon-close {
        width: 18px;
        height: 18px;
        cursor: pointer;
      }
    }
    .modal-body {
      padding: 20px 24px;
      overflow-y: auto;
      .section {
        margin-bottom: 24px;
        .section-title {
          font-size: 14px;
          font-weight: 600;
          color: #1a1a1a;
          margin-bottom: 14px;
        }
        .product-search {
          display: flex;
          align-items: center;
          background: #f2f3f5;
          border-radius: 20px;
          padding: 8px 16px;
          width: 100%;
          input {
            border: none;
            outline: none;
            background: transparent;
            flex: 1;
          }
          .search-btn {
            padding-left: 16px;
            border-left: 1px solid rgba(0, 0, 0, 0.1);
            cursor: pointer;
            color: #666666;
          }
        }
        .product-list {
          max-height: 200px;
          overflow-y: auto;
          margin-top: 12px;
          border: 1px solid #f0f0f0;
          border-radius: 8px;
          .product-item {
            display: flex;
            align-items: center;
            padding: 10px 14px;
            cursor: pointer;
            border-bottom: 1px solid #f5f5f5;
            &:last-child {
              border-bottom: none;
            }
            &.active {
              background: rgba(255, 89, 103, 0.06);
            }
            .check-box {
              width: 20px;
              height: 20px;
              margin-right: 12px;
              flex-shrink: 0;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .product-img {
              width: 48px;
              height: 48px;
              border-radius: 5px;
              object-fit: cover;
              margin-right: 12px;
              border: 1px solid #f0f0f0;
              flex-shrink: 0;
            }
            .product-text {
              .p-name {
                font-size: 14px;
                color: #333333;
              }
              .p-no {
                font-size: 12px;
                color: #999999;
                margin-top: 4px;
              }
            }
          }
          .empty {
            text-align: center;
            color: #999999;
            padding: 30px 0;
          }
        }
        .selected-product {
          border: 1px solid #f0f0f0;
          border-radius: 8px;
          padding: 12px;
          margin-bottom: 14px;
          .selected-head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;
            .sp-name {
              font-size: 14px;
              font-weight: 500;
              color: #1a1a1a;
            }
            .sp-remove {
              font-size: 13px;
              color: #ff5967;
              cursor: pointer;
            }
          }
        }
        .info-row {
          display: flex;
          align-items: center;
          margin-bottom: 14px;
          .info-label {
            width: 90px;
            flex-shrink: 0;
            font-size: 13px;
            color: #666666;
          }
          .info-value {
            font-size: 13px;
            color: #1a1a1a;
            flex: 1;
          }
          .form-input {
            flex: 1;
            height: 36px;
            padding: 0 12px;
            border: 1px solid #e6e6e6;
            border-radius: 6px;
            outline: none;
            font-size: 13px;
            &:focus {
              border-color: #ff5967;
            }
          }
          .form-select {
            flex: 1;
          }
          .date-picker {
            flex: 1;
            ::v-deep .ivu-input {
              border: 1px solid #e6e6e6;
              border-radius: 6px;
              height: 36px;
            }
          }
        }
        .spec-grid {
          border: 1px solid #f0f0f0;
          border-radius: 8px;
          .spec-head,
          .spec-row {
            display: flex;
            align-items: center;
            span {
              flex: 1;
              text-align: center;
              font-size: 13px;
              padding: 8px 0;
            }
            .spec-input {
              flex: 1;
              margin: 6px;
              height: 32px;
              border: 1px solid #e6e6e6;
              border-radius: 6px;
              text-align: center;
              outline: none;
            }
          }
          .spec-head {
            background: #f7f7f7;
            color: #666666;
            font-weight: 500;
          }
          .spec-row {
            border-top: 1px solid #f5f5f5;
            color: #333333;
          }
        }
      }
    }
    .modal-footer {
      padding: 16px 24px;
      border-top: 1px solid #f0f0f0;
      display: flex;
      justify-content: flex-end;
      .cancel-btn {
        width: 120px;
        height: 40px;
        border-radius: 20px;
        border: 1px solid #e3e3e3;
        background: #ffffff;
        color: #999999;
        font-size: 14px;
        margin-right: 12px;
        cursor: pointer;
      }
      .confirm-btn {
        width: 140px;
        height: 40px;
        border-radius: 20px;
        border: none;
        background: #ff5967;
        color: #ffffff;
        font-size: 14px;
        cursor: pointer;
        &:hover {
          background: #ff5067;
        }
      }
    }
  }
}
</style>
